import { ReasonRejectionComment } from "@interfaces/slices";
import { Box, Stack, Typography } from "@mui/material";

export const ComentarioMotivoRechazo = (props: ReasonRejectionComment) => {
    return (
        <Box ml={4} mr={4} mt={4} mb={3} maxWidth={"300px"}>
            <Stack textAlign={"center"} rowGap={2}>
                <Typography variant="body1" fontWeight={600} color="main3">
                    Motivo de rechazo
                </Typography>
                <Typography>{props.text.split("|").at(1)}</Typography>
            </Stack>
        </Box>
    );
};
